<script lang="ts">
  export let title: string | null = null;
  export let description =
    'SUBASTAS. Las raíces de SubastasFral son los eventos presenciales, con la importante figura de un Martillero Público matriculado para certificar todo el proceso.Debido a la pandemia fusionamos lo digital con lo tradicional, por lo que asi nacieron nuestras subastas online.. Todas nuestras subastas online estan respaldadas por un equipo de Martilleros Públicos matriculados.';
</script>

<svelte:head>
  <title>{`${title ? `${title} | ` : ''} Subastasfral - Subastas desde 1985`}</title>
  <meta name="description" content={description} />
  <slot />
</svelte:head>
